import { useState } from "react";
import { Text, Icon, Button } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";
import PropertySelector from "@components/PropertySelector/PropertySelector";
import { useDemoMinskogStore } from "../../store/DemoMinskogStore";
import { DEMO_PROMPTS } from "../../constants/demoPrompts";

export default function NoActivePropsView() {
  const [openPropertySelector, setOpenPropertySelector] = useState(false);
  const { DemoBlockFunctionWrapper } = useDemoMinskogStore();

  return (
    <div
      className="relative bg-cloud-50"
      style={{ minHeight: "100dvh" }}
    >
      <TailwindWrapper>
        <div className="flex flex-col items-center m-4 p-4 bg-cloud-200 gap-6 rounded-2xl w-[calc(100%-32px)] sm:w-[343px] mt-8 sm:mx-auto">
          <Icon
            name="Location"
            size="large"
            className="bg-white-50 rounded-md p-3"
          />
          <div className="flex flex-col gap-1">
            <Text variant="text-lg/leading-normal/medium" className="text-center">
              Ingen fastighet vald
            </Text>
            <Text
              variant="text-base/leading-normal/normal"
              className="text-[#1A1A1A] text-center"
            >
              Välj en eller flera fastigheter för att se informationen i karta, överblick och prisjämförelse.
            </Text>
          </div>
          <Button
            variant="primary"
            onClick={() =>
              DemoBlockFunctionWrapper(
                () => setOpenPropertySelector(true),
                DEMO_PROMPTS.ADD_PROPERTIES
              )
            }
          >
            <Icon
              name="PlusOutlined"
              size="medium"
              className="text-white-50"
            />
            Välj fastighet
          </Button>
        </div>
        <PropertySelector
          isOpen={openPropertySelector}
          onClose={() => setOpenPropertySelector(false)}
        />
      </TailwindWrapper>
    </div>
  );
}
